import { render, staticRenderFns } from "./VaInnerLoading.demo.vue?vue&type=template&id=c95ef866&scoped=true&"
import script from "./VaInnerLoading.demo.vue?vue&type=script&lang=js&"
export * from "./VaInnerLoading.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95ef866",
  null
  
)

export default component.exports